import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppFloat.css';

const WHATSAPP_NUMBER = '5512991757395';

const WhatsAppFloat = () => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Fale conosco no WhatsApp"
    >
      <FaWhatsapp className="whatsapp-float-icon" />
    </a>
  );
};

export default WhatsAppFloat;
